import dayjs from 'dayjs'
import { defineStore } from 'pinia'
import { computed, ref, shallowRef, triggerRef } from 'vue'

import { isSubscriber } from '@/shared/composables/local-storage'

// Connection status type (WebSocket connection state)
type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'disconnecting' | 'error'

export const useIMStore = defineStore('im-store', () => {
  // Connection status (WebSocket connection state)
  const connectionStatus = ref<ConnectionStatus>('disconnected')
  // Authorization status (can send messages)
  const isAuthorized = ref(false)
  // FCM web push token (for enable/disable /api/user-device-token)
  const deviceToken = ref<string | undefined>()
  const lastUpdate = shallowRef(dayjs())

  // Computed properties for backward compatibility and convenience
  const imIsReady = computed(() => isAuthorized.value)
  const userImIsReady = computed(() => {
    return imIsReady.value && isSubscriber()
  })

  // Setter for connection status
  const setConnectionStatus = (status: ConnectionStatus) => {
    if (connectionStatus.value !== status) {
      lastUpdate.value = dayjs()
      triggerRef(lastUpdate)
    }
    connectionStatus.value = status
  }

  // Setter for authorization status
  const setAuthorized = (authorized: boolean) => {
    if (isAuthorized.value !== authorized) {
      lastUpdate.value = dayjs()
      triggerRef(lastUpdate)
    }
    isAuthorized.value = authorized
  }

  const setDeviceToken = (token: string | undefined) => {
    deviceToken.value = token
  }

  return {
    // Main state
    connectionStatus,
    isAuthorized,
    deviceToken,
    setConnectionStatus,
    setAuthorized,
    setDeviceToken,
    lastUpdate,
    userImIsReady,

    // Legacy/compatibility properties
    imIsReady,
  }
})
